var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var eregAuthMethodConfigTemplate = require('./eregAuthMethodConfigTemplate.hbs');
var sessionStorageService = require('./../../storage/sessionStorageService');
var applicationUtils = require('./../../applicationUtils');
var EregAuthMethodConfigModel = require('./EregAuthMethodConfigModel');

var SERIAL_NUMBER_PROPERTY_NAME = sessionStorageService.SESSION_STORAGE_KEYS.serialNumber;

/**
 * View for determining eReg Authentication method.
 *
 * @class EregAuthMethodConfigView
 * @constructor
 * @param options {Object}
 */
module.exports = TorsoView.extend({
  className: 'brec-authentication__main',
  moduleNamespace: 'eregAuthMethodConfigView',
  template: eregAuthMethodConfigTemplate,

  events: {
    'click [data-button-retry]': 'reloadPage'
  },

  /**
   * @method initialize
   * @param options {Object}
   * @override
   */
  initialize: function() {
    // Bind this context to methods used by promises
    _.bindAll(this, '_setConfigLoadErrors',
                    '_redirectToAuthPage');

    var serialNumber = sessionStorageService.getItem(SERIAL_NUMBER_PROPERTY_NAME);
    this.set('loadingConfigs', true);

    this.listenTo(this, 'change:loadingConfigs', this.render);

    // Load the configuration
    this._configModel = new EregAuthMethodConfigModel({serialNumber: serialNumber});
    this._configModel
      .fetch()
      .fail(this._setConfigLoadErrors)
      .always(this._redirectToAuthPage);
  },

  reloadPage: function() {
    window.location.href = applicationUtils.currentApplication.fullUrlPath;
  },

  /**
   * Determines if have all the needed configurations
   * @private
   * @method _validateConfigurations
   */
  _validateConfigurations: function() {
    return this._configModel && this._configModel.has('tabletGroup') && this._configModel.get('onsiteFeatureConfig');
  },

  /**
   * Determines the redirect url that should be used for the authentication page
   * @private
   * @method getAuthPage
   */
  _getAuthPage: function() {
    var expressCheckInEnabled = this._configModel.get('tabletGroup').expressCheckInEnabled;
    var authMethod;

    if (expressCheckInEnabled) {
      authMethod = this._configModel.get('onsiteFeatureConfig').tabletExpressCheckinAuthMethod;
    } else {
      authMethod = this._configModel.get('onsiteFeatureConfig').tabletFullEregAuthMethod;
    }

    var redirectUrl;
    if (authMethod === 'BARCODE')  {
      redirectUrl = applicationUtils.currentApplication.fullUrlPath + '#patient/authentication/barcode';
    } else {
      redirectUrl = applicationUtils.currentApplication.fullUrlPath + '#patient/authentication/manual';
    }

    return redirectUrl;
  },

  /**
   * Pulls the config load error by its i18n key and sets it on the view state.
   * @private
   * @method _setConfigLoadErrors
   */
  _setConfigLoadErrors: function() {
    this.set('error', true);
  },

  /**
   * Display the results of loading the configuration.
   * @private
   * @method _displayLoadResult
   */
  _redirectToAuthPage: function() {
    if (!this.get('error')) {
      if (this._validateConfigurations()) {
        window.location.href = this._getAuthPage();
      } else {
        this.set('error', true);
      }
    }
    this.set('loadingConfigs', false);
  }
});
